module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/4_80f254b8e8ba28b9727fd2c5c5d58437.png";